const inputIdParamName = 'inputId';

export default {
    preventNegativeNumbers
}

export function preventNegativeNumbers() {
    var numericInputs = $('input[type="number"][min="0"]'); 
    numericInputs.on('change', (e) => {
        var input = $(e.currentTarget);
        input.val(input.val().toString().replace(/[^0-9\.]/i, ''));
    });

    var textInputs = $('input[type="text"][min="0"]'); 
    textInputs.on('change', (e) => {
        var input = $(e.currentTarget);
        input.val(input.val().toString().replace(/\-/i, ''));
    });
}